// Textos de la revisión de los viajes de empresa de Taxi / VTC: bandeja de la
// empresa, detalle, rechazo y ajustes globales de WAIIS. Se registran junto al
// resto de vocabularios en AppComponent.
export const locale = {
  lang: 'es',
  data: {
    RIDE_REVIEWS: {
      TITLE: 'Revisión inteligente de viajes',
      RETRY: 'Reintentar',
      LOAD_ERROR: 'No se han podido cargar los viajes por revisar.',
      KPIS_ERROR: 'No se han podido cargar los indicadores.',
      BADGE: {
        RED: 'Revisión obligatoria',
        ORANGE: 'Revisión recomendada',
        YELLOW: 'Aprobado · baja sospecha',
        GREEN: 'Aprobado automático',
        APPROVED: 'Aprobado por la empresa',
        REJECTED: 'Rechazado por la empresa',
      },
      KPI: {
        ANALYZED: 'Viajes analizados · 30 días',
        ANALYZED_HINT: 'Todos los pagados por la empresa',
        AUTO: 'Aprobados sin intervención',
        AUTO_HINT: '{{count}} con baja sospecha, registrados',
        AUTO_HINT_ONE: '1 con baja sospecha, registrado',
        PENDING: 'Requieren tu decisión',
        PENDING_HINT: '{{count}} obligatorias',
        PENDING_HINT_ONE: '1 obligatoria',
        NOTHING_PENDING: 'Nada pendiente',
      },
      FILTER: {
        ARIA: 'Qué viajes ver',
        PENDING: 'Pendientes',
        RED: 'Obligatoria',
        ORANGE: 'Recomendada',
        YELLOW: 'Baja sospecha',
        RESOLVED: 'Resueltos',
      },
      HOW: {
        TITLE: 'Cómo funciona',
        GREEN: 'Encaja con horario, origen, destino y coste habituales. No lo ves.',
        YELLOW: 'Una desviación menor. Se aprueba y queda registrado.',
        ORANGE: 'Varias señales atípicas. Conviene mirarlo.',
        RED: 'Fuera de política o posible uso personal. Decides tú.',
        GREEN_TITLE: 'Aprobado automático',
        YELLOW_TITLE: 'Baja sospecha',
        NOTE: 'Para que funcione, la app pide al empleado un motivo en cada viaje con pago de empresa y una justificación cuando el viaje se sale de su patrón.',
      },
      CARD: {
        REASON: 'Motivo declarado',
        JUSTIFICATION: 'Justificación',
        NO_JUSTIFICATION: 'No aportada',
        PAID_BY_COMPANY: 'Pagado por la empresa',
        PLUS_EMPLOYEE: '+ {{amount}} empleado',
        POINTS: '{{count}} pts',
        POINTS_ONE: '1 pt',
        APPROVE: 'Aprobar',
        REJECT: 'Rechazar',
        DETAIL: 'Ver detalle',
        NO_REASON: 'Sin motivo',
      },
      EMPTY: {
        PENDING_TITLE: 'Nada que revisar',
        PENDING: 'Todos los viajes pagados por la empresa encajan con el patrón de cada empleado.',
        OTHER_TITLE: 'Sin viajes aquí',
      },
      MORE: 'Ver más',
      SHOWING: 'Mostrando {{shown}} de {{total}} viajes',
      SHOWING_ONE: 'Mostrando {{shown}} de 1 viaje',
      APPROVED_OK: 'Viaje de {{name}} aprobado',
      APPROVE_ERROR: 'No se ha podido aprobar el viaje',
      REJECTED_OK: 'Viaje rechazado: se reclamará el importe al empleado y se le avisará',
      REJECT_ERROR: 'No se ha podido rechazar el viaje',
      ALREADY_DECIDED: 'Este viaje ya tiene una decisión',
      ACCEPT: 'Aceptar',
      DETAIL: {
        CLOSE: 'Cerrar',
        LOAD_ERROR: 'No se ha podido cargar el viaje.',
        SIGNALS: 'Señales',
        HARD_RULES: 'Reglas que obligan a revisarlo',
        SCORE: 'Puntuación',
        SCORE_VALUE: '{{count}} puntos',
        SCORE_VALUE_ONE: '1 punto',
        PRODUCT: 'Servicio',
        REVIEW: 'Revisión',
        DECISION: 'Decisión',
        DECIDED_BY: '{{name}} · {{date}}',
        REJECT_REASON: 'Motivo del rechazo',
        REJECT_MESSAGE: 'Mensaje al empleado',
        PAYMENT: 'Reparto del pago',
        COMPANY: 'Empresa',
        EMPLOYEE: 'Tarjeta del empleado',
        NO_AMOUNT: 'Sin importe todavía',
      },
      REJECT: {
        TITLE: 'Rechazar viaje',
        INTRO: 'Vas a rechazar el viaje de {{name}} · {{route}}. Lo que pagó la empresa se reclamará al empleado y se le avisará.',
        REASON: 'Motivo',
        REASON_HINT: 'Se envía al empleado',
        REASON_REQUIRED: 'Elige un motivo.',
        MESSAGE: 'Mensaje para el empleado',
        MESSAGE_PLACEHOLDER: 'Mensaje para el empleado (opcional)…',
        CANCEL: 'Cancelar',
        SUBMIT: 'Rechazar y notificar',
        SUBMITTING: 'Rechazando…',
      },
      REASON: {
        personal_trip: 'Viaje personal, no corporativo',
        carpooling_available: 'Existía carpooling disponible',
        outside_policy_schedule: 'Fuera de horario de la política',
        missing_justification: 'Falta justificación',
        unauthorized_cost: 'Coste no autorizado',
      },
      SIGNAL: {
        weekend: 'Viaje en fin de semana',
        night: 'Horario de madrugada',
        unrelated_origin: 'Origen sin relación con una sede, una estación o un lugar conocido',
        unrelated_destination: 'Destino sin relación con una sede, una estación o un lugar conocido',
        cost_above_average: 'Coste superior a la media del empleado',
        duplicate: 'Posible duplicidad con otro viaje casi idéntico',
        excessive_use: 'Más viajes de empresa de lo permitido esta semana',
        missing_justification: 'Sin justificación en un viaje atípico',
      },
      HARD_RULE: {
        unrelated_destination_without_justification: 'Destino no relacionado sin justificación',
        off_hours_unrelated_trip: 'Fin de semana o madrugada con origen y destino no relacionados',
        duplicate: 'Posible viaje duplicado',
        cost_double_without_justification: 'Coste del doble de la media o más sin justificación',
      },
      SETTINGS: {
        NOTE_TITLE: 'Valen para todas las empresas',
        NOTE_TEXT: 'Cambiarlos solo afecta a los viajes que se puntúen a partir de ahora: los ya revisados conservan sus puntos.',
        LOAD_ERROR: 'No se han podido cargar los ajustes de la revisión.',
        SAVE: 'Guardar cambios',
        SAVING: 'Guardando…',
        SAVED: 'Ajustes de la revisión guardados',
        SAVE_ERROR: 'No se han podido guardar los ajustes',
        REQUIRED: 'Obligatorio.',
        POINTS_TITLE: 'Puntos por señal',
        POINTS_SUB: 'Lo que suma cada señal cuando salta.',
        POINT: {
          weekend: 'Fin de semana',
          night: 'Madrugada',
          unrelatedOrigin: 'Origen no relacionado',
          unrelatedDestination: 'Destino no relacionado',
          duplicate: 'Duplicidad',
          excessiveUse: 'Uso excesivo',
          missingJustification: 'Sin justificación',
        },
        LEVELS_TITLE: 'Niveles',
        LEVELS_SUB: 'Puntos a partir de los que un viaje pasa a cada nivel. Naranja y rojo quedan pendientes de la empresa.',
        LEVEL_YELLOW: 'Baja sospecha desde',
        LEVEL_ORANGE: 'Revisión recomendada desde',
        LEVEL_RED: 'Revisión obligatoria desde',
        COST_TITLE: 'Coste',
        COST_SUB: 'Comparación con la media de los otros viajes de empresa del empleado.',
        COST_STEP: 'Escalón {{n}}',
        COST_STEP_PCT: '% sobre la media',
        COST_STEP_POINTS: 'Puntos',
        COST_HARD_RULE: '% sobre la media que obliga a revisar sin justificación',
        COST_HISTORY_DAYS: 'Días de historial',
        COST_MIN_RIDES: 'Viajes mínimos para calcular la media',
        SCHEDULE_TITLE: 'Horario y uso',
        SCHEDULE_SUB: 'Madrugada y número de viajes por semana.',
        NIGHT_END_HOUR: 'La madrugada acaba a las (hora)',
        MAX_WEEKLY_RIDES: 'Viajes por semana permitidos',
        DISTANCES_TITLE: 'Distancias',
        DISTANCES_SUB: 'Cuándo un punto está cerca de un lugar relacionado y cuándo dos viajes son el mismo.',
        PLACE_RADIUS: 'Radio de un lugar relacionado (m)',
        DUPLICATE_RADIUS: 'Radio de un viaje duplicado (m)',
        DUPLICATE_MINUTES: 'Minutos entre viajes duplicados',
        STATIONS_TITLE: 'Estaciones',
        STATIONS_SUB: 'Qué paradas cuentan como lugar relacionado. Sin ninguna marcada, no cuenta ninguna.',
        STATION: {
          bus_stop: 'Paradas de autobús',
          train_station: 'Estaciones de tren',
          metro_station: 'Estaciones de metro',
        },
        PLACES_TITLE: 'Lugares conocidos',
        PLACES_SUB: 'Además de las sedes y las estaciones, para todas las empresas.',
        PLACE_NAME: 'Nombre',
        PLACE_LAT: 'Latitud',
        PLACE_LNG: 'Longitud',
        PLACE_ADD: 'Añadir lugar',
        PLACE_REMOVE: 'Quitar {{name}}',
        PLACES_EMPTY: 'Sin lugares conocidos.',
      },
    },
  },
};
